module.exports = __webpack_public_path__ + "static/media/GalleryImage05.501db876.jpg";